const phoneNumberRegex = /^\d{8}$/;

export const normalizePhoneNumber = (phoneNumber: string) => phoneNumber.replace(/\s+/g, '');

export const validPhoneNumber = (phoneNumber: string) => phoneNumberRegex.test(normalizePhoneNumber(phoneNumber));
